import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          welcome: 'Welcome to Ithnain Meeting',
          joinMeeting: 'Join Meeting',
          createMeeting: 'Create Meeting',
          'Joining meeting...': 'Joining meeting...',
          'Waitlist status': 'Waitlist status',
          'Leave': 'Leave',
          'Settings': 'Settings',
          'Cancel': 'Cancel',
          'Unable to join meeting': 'Unable to join meeting',
          'Authentication token is missing': 'Authentication token is missing',
          'Meeting ID is missing': 'Meeting ID is missing',
          'Go Back': 'Go Back',
          'Error': 'Error',
          'Failed to join meeting': 'Failed to join meeting',
          'Failed to join meeting. Please check your permissions.': 'Failed to join meeting. Please check your permissions.',
          'Initializing meeting...': 'Initializing meeting...',
          'Back to App': 'Back to App',
        },
      },
      ar: {
        translation: {
          welcome: 'مرحباً بكم في اجتماع إثنين',
          joinMeeting: 'انضم إلى الاجتماع',
          createMeeting: 'إنشاء اجتماع',
          'Joining meeting...': 'جارٍ الانضمام إلى الاجتماع...',
          'Waitlist status': 'حالة قائمة الانتظار',
          'Leave': 'مغادرة',
          'Settings': 'الإعدادات',
          'Cancel': 'إلغاء',
          'Unable to join meeting': 'غير قادر على الانضمام إلى الاجتماع',
          'Authentication token is missing': 'رمز المصادقة مفقود',
          'Meeting ID is missing': 'معرف الاجتماع مفقود',
          'Go Back': 'رجوع',
          'Error': 'خطأ',
          'Failed to join meeting': 'فشل الانضمام إلى الاجتماع',
          'Failed to join meeting. Please check your permissions.': 'فشل الانضمام إلى الاجتماع. يرجى التحقق من الصلاحيات.',
          'Initializing meeting...': 'جارٍ تهيئة الاجتماع...',
          'Back to App': 'العودة إلى التطبيق',
        },
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

